module.exports = __webpack_public_path__ + "static/media/instabannertablet.df74c46a.png";